import React from 'react';
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { BlackMask } from '../../../../components/mask';

const MeLoading = props => {
    useStyles(classes)
    const { loading } = props || {}

    return loading ? <div className={classes.GlobalLoading}>
        <div className={classes.LoadingItem}></div>
        <BlackMask style={{backgroundColor:`rgba(0, 0, 0, .2)`, zIndex: 13}} />
    </div>: <React.Fragment></React.Fragment>
}

export default MeLoading